import { authQueryKeys as e } from "./useAuthQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/queries/state/useSuspenseMeQuery.ts
var r = () => t({
	queryKey: e.me(),
	queryFn: n.me,
	retry: !1
});
//#endregion
export { r as useSuspenseMeQuery };
